import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import emoji from "../../Assets/images/emoji-about-us.png";
import {
  BiLogoFacebook,
  BiLogoInstagram,
  BiLogoLinkedin,
  BiLogoTwitter,
} from "react-icons/bi";
import { useSelector } from "react-redux";
import { selectSignedIn, selectUserData } from "../../Redux/UserSlice";
import { api_url, defaultHeaders } from "../../Constants/web_services";
import { Rating } from "react-simple-star-rating";
import Swal from "sweetalert2";
import moment from "moment/moment";

function Footer() {
  const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);

  const location = useLocation();

  const [review, setReview] = useState("");
  const [message, setMessage] = useState("");

  const [rating, setRating] = useState(0);

  const handleRating = (rate) => {
    setRating(rate);

  };
  const onPointerEnter = () => console.log();
  const onPointerLeave = () => console.log();
  const onPointerMove = (value, index) => console.log();

  const handleReview = async () => {
    try {
      const response = await fetch(`${api_url}/api/reviewsubmit`, {
        headers: defaultHeaders,
        method: "POST",
        body: JSON.stringify({
          user_id: userData.id,
          company_id: 0,
          order_id: 0,
          review,
          desc_review: message,
          rating,
        }),
      });


      if (response.ok === true) {

        setReview("");
        setMessage("");
        setRating("");

        Swal.fire({
          title: "Success!",
          text: "Your review has been submitted successfully.",
          icon: "success",
          showConfirmButton: 'false',
        });
      } else {
        console.log("Review submission failed.");
      }

    } catch (e) {
      console.error("An error occurred:", e);
    }
  };

  return (
    <>
      <div
        className={`${location.pathname === "/search" ||
          location.pathname === "/user-profile"
          ? " d-none"
          : " d-block"
          }`}
      >
        <footer className="site-footer footer-light footer-link">
          {/* FOOTER NEWSLETTER START */}
          {isSignedIn ? (
            <>
              <div className="footer-top-newsletter">
                <div className="container">
                  <div className="sf-news-letter ">
                    <img src={emoji} width={"200px"} alt="" />
                    <span className="p-3 m-0 col-md-3 text-center">
                      <p>Any Suggestions</p>
                      <p>Any Review</p>
                      <p>Write Us</p>
                    </span>
                    <div className="form-group sf-news-l-form">
                      <div className="row justify-content-end col-auto">
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Your Review"
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                          />
                        </div>
                        <div>
                          <textarea
                            className="form-control"
                            placeholder="Give message to others"
                            rows="2"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                          >
                            {message}
                          </textarea>
                        </div>
                        <div className="col-md-9">
                          <Rating
                            onClick={handleRating}
                            onPointerEnter={onPointerEnter}
                            onPointerLeave={onPointerLeave}
                            onPointerMove={onPointerMove}
                          /* Available Props */
                          />
                          <button
                            type="button"
                            className="sf-sb-btn m-2"
                            onClick={handleReview}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}

          {/* FOOTER BLOCKES START */}
          <div className="footer-top">
            <div className="container">
              <div className="row justify-content-center">
                {/* Footer col 1*/}
                <div className="col-lg-2 col-md-6 col-sm-6  m-b30">
                  <div className="sf-site-link sf-widget-link">
                    <h4 className="sf-f-title">Site Links</h4>
                    <ul className="ps-0">
                      <li>
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li>
                        <Link to={"/about-us"}>About</Link>
                      </li>
                      <li>
                        <Link to={"/contact-us"}>Contact Us</Link>
                      </li>
                      {isSignedIn ? (
                        <li>
                          <Link to={`/user-profile/${userData?.id}`}>
                            User Panel
                          </Link>
                        </li>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="col-lg-10 col-md-6 col-sm-6 m-b30">
                  <div className="sf-footer-bottom-section">
                    <div className="sf-f-logo m-2">
                      <Link to={"/"}>
                        <img src={logo} width={"150px"} alt="" />
                      </Link>
                    </div>
                    <div className="sf-f-copyright">
                      <span>
                        Copyright {moment().format('y')} | Technottix &#169; All Rights Reserved
                      </span>
                    </div>
                    <div className="sf-f-social">
                      <ul className="socila-box">
                        <li>
                          <Link to={"https://www.twitter.com/"}>
                            <BiLogoTwitter />
                          </Link>
                        </li>
                        <li>
                          <Link to={"https://www.facebook.com/"}>
                            <BiLogoFacebook />
                          </Link>
                        </li>
                        <li>
                          <Link to={"https://www.linkedin.com/"}>
                            <BiLogoLinkedin />
                          </Link>
                        </li>
                        <li>
                          <Link to={"https://www.instagram.com/"}>
                            <BiLogoInstagram />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FOOTER COPYRIGHT */}
          <div className="footer-bottom">
            <div className="container"></div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;
